module.exports = __webpack_public_path__ + "static/media/planet4.4c940984.png";